import styled from 'styled-components'
import { color } from 'utils'

const TabMenuNew = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px;
  background-color: ${color('dark600')};
`

export default TabMenuNew
